/**
 *
 * TableCellActions
 *
 */

import {
  Box,
  Button,
  Divider,
  Typography,
  withStyles,
} from "@material-ui/core";
import GetAppIcon from "@material-ui/icons/GetApp";
import HistoryIcon from "@material-ui/icons/History";
import MailIcon from "@material-ui/icons/Mail";
import propTypes from "prop-types";
import React from "react";
import { ReactComponent as LinkIcon } from "../../Assets/Icons/link.svg";
import { ReactComponent as AddIcon } from "../../Assets/Images/add.svg";
import { ReactComponent as DeleteIcon } from "../../Assets/Images/delete.svg";
import { ReactComponent as EditIcon } from "../../Assets/Images/edit.svg";
import { ReactComponent as EyeIcon } from "../../Assets/Images/eye.svg";
import { ReactComponent as InviteIcon } from "../../Assets/Images/invite.svg";
import VerifiedStatusChip from "../VerifiedStatusChip/";
const ActionButton = withStyles({
  root: {
    "&:hover": { background: "transparent" },
    padding: "0px 0px",
    minWidth: "0px",
  },
})(Button);

const TableActionCell = ({
  viewMethod,
  editMethod,
  deleteMethod,
  canView,
  canDelete,
  canEdit,
  canDownload,
  downloadUrl,
  downloadMethod,
  getKeyAccess,
  getKeyMethod,
  canInvite,
  inviteMethod,
  canInviteReviewers,
  inviteRevMethod,
  showDefault,
  onDefault,
  canRedirect,
  onRedirect,
  canAdd,
  addMethod,
  isAddText,
  addTitle,
  historyMethod,
  canViewHistory,
  isMail,
}) => (
  <Box display="flex">
    {canDownload &&
      (downloadMethod ? (
        <ActionButton disableRipple onClick={downloadMethod} color="primary">
          <GetAppIcon style={{ marginRight: 4 }} />
          DOWNLOAD
        </ActionButton>
      ) : (
        <ActionButton
          disableRipple
          component="a"
          color="primary"
          href={downloadUrl}
          target="_blank"
        >
          DOWNLOAD
        </ActionButton>
      ))}
    {((canDownload && canEdit) || (canDownload && canDelete)) && (
      <Divider orientation="vertical" />
    )}
    {canAdd && (
      <ActionButton
        disableRipple
        onClick={addMethod}
        style={{ minWidth: isAddText ? `125px` : `0px` }}
      >
        {isAddText && (
          <Typography component={`h3`} style={{ marginRight: 7 }}>
            {addTitle}
          </Typography>
        )}
        <AddIcon />
      </ActionButton>
    )}
    {canAdd && canEdit && <Divider orientation="vertical" />}
    {canView && (
      <ActionButton
        disableRipple
        onClick={(e) => {
          e.stopPropagation();
          viewMethod(e);
        }}
      >
        <EyeIcon />
      </ActionButton>
    )}
    {((canView && canEdit) || (canView && canDelete)) && (
      <Divider orientation="vertical" />
    )}
    {canInviteReviewers && (
      <ActionButton
        disableRipple
        color="primary"
        onClick={() => inviteRevMethod()}
      >
        Invite to review
      </ActionButton>
    )}
    {canInviteReviewers && <Divider orientation="vertical" />}
    {canInvite && (
      <ActionButton
        disableRipple
        color="primary"
        onClick={(e) => {
          e.stopPropagation();
          inviteMethod(e);
        }}
      >
        {isMail ? <MailIcon color="secondary" /> : <InviteIcon />}
      </ActionButton>
    )}
    {canInvite && <Divider orientation="vertical" />}
    {canEdit && (
      <ActionButton
        disableRipple
        color="primary"
        onClick={(e) => {
          e.stopPropagation();
          editMethod(e);
        }}
      >
        <EditIcon />
      </ActionButton>
    )}
    {((canDelete && canEdit) || (canDelete && canView)) && (
      <Divider orientation="vertical" />
    )}
    {canDelete && (
      <ActionButton
        disableRipple
        color="secondary"
        onClick={(e) => {
          e.stopPropagation();
          deleteMethod(e);
        }}
      >
        <DeleteIcon />
      </ActionButton>
    )}
    {showDefault && (
      <span onClick={onDefault} style={{ cursor: "pointer", marginLeft: 5 }}>
        <VerifiedStatusChip
          data-status="light"
          label="Set as Default"
          style={{ cursor: "pointer" }}
        />
      </span>
    )}
    {canRedirect && (canDelete || canEdit) && (
      <Divider orientation="vertical" />
    )}
    {canRedirect && (
      <ActionButton
        disableRipple
        color="secondary"
        onClick={(e) => {
          e.stopPropagation();
          onRedirect(e);
        }}
      >
        <LinkIcon width={16} height={16} />
      </ActionButton>
    )}
    {((canViewHistory && canEdit) || (canViewHistory && canDelete)) && (
      <Divider orientation="vertical" />
    )}
    {canViewHistory && (
      <ActionButton
        disableRipple
        color="secondary"
        onClick={(e) => {
          e.stopPropagation();
          historyMethod(e);
        }}
      >
        <HistoryIcon />
      </ActionButton>
    )}
  </Box>
);
TableActionCell.propTypes = {
  downloadUrl: propTypes.string,
  viewMethod: propTypes.func,
  editMethod: propTypes.func,
  deleteMethod: propTypes.func,
  canView: propTypes.bool,
  canDelete: propTypes.bool,
  canEdit: propTypes.bool,
  canDownload: propTypes.bool,
  getKey: propTypes.bool,
  getKeyMethod: propTypes.bool,
};
export default TableActionCell;
